<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/home']">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a>Dashboards</a>
        </li>
      </ol>
    </div>
</div>

<div class="modal fade" bsModal #addDashboard="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">ADD DASHBOARD</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeAddDashboard()"></button>
      </div>
      <div class="modal-body">
        <div class="row" *ngIf="newDashboard">
          <div class="form-group mb-3">
            <label class="form-label" for="newDashboardName">Name</label>
            <input type="string" class="form-control" id="newDashboardName" [(ngModel)]="newDashboard.name">
          </div>
          <div class="form-group mb-3">
            <label class="form-label" for="newDashboardCategory">Category</label>
            <input type="string" class="form-control" id="newDashboardCategory" [(ngModel)]="newDashboard.category">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="addDashboard.hide()" class="btn btn-white">Close</button>
        <button (click)="addNewDashboard();addDashboard.hide()" class="btn btn-white">Add</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #addDashboardList="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">ADD DASHBOARD LIST</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeAddDashboardList()"></button>
      </div>
      <div class="modal-body">
        <div class="row" *ngIf="newDashboardList">
          <div class="col-4 form-group mb-3">
            <label class="form-label" for="newDashboardName">List Name</label>
            <input type="string" class="form-control" id="newDashboardListName" [(ngModel)]="newDashboardList.listName">
         
            <div class="list-group mt-3">
              <div class="list-group-item d-flex align-items-center">
                <div class="flex-fill">
                  <div class="fw-bold">Auto Play</div>
                </div>
                <div>
                  <div class="form-switch me-n1">
                    <input type="checkbox" class="form-check-input" id="editWidgetSwitch" [(ngModel)]="newDashboardList.autoPlay">
                    <label class="form-check-label" for="editWidgetSwitch"></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <label class="form-label">Publish</label>
            <div>
              <button *ngIf="newDashboardList.publishedBy == null" class="btn btn-outline-danger btn-sm" type="submit" (click)="publishToPublicDashboard()">Publish Public</button>
              <button *ngIf="newDashboardList.publishedBy != nul" class="btn btn-outline-danger btn-sm" type="submit" (click)="unPublishToPublicDashboard()">Un Publish Public</button>
            </div>
            <div class="mt-1">
              <small class="text-warning" *ngIf="canPublishToPublic()">Publishing will mean your dashboards are accessible to anyone with the generated URL.</small>
              <small class="text-warning" *ngIf="!canPublishToPublic()">Your list contains dashboards that have not been made public.</small>
            </div>
          </div>
          <div class="col-4" *ngIf="newDashboardList.publishedBy != null">
            <label class="form-label">Public URL</label>
            <div class="form-group" >
              <textarea type="text" rows="3"
                            class="form-control input-sm"
                            [(ngModel)]="publicUrl" readonly></textarea>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="newDashboardList">
          <div class="col-12">
            <div class="card">
              <div class="card-header h-100px">
                <h1>Dashboard List</h1>
                <div class="input-group">
                  <select class="form-select" [(ngModel)]="dashboardToAdd">
                    <option *ngFor="let source of sourceDashboardList" [value]="source.dashboardId">{{source.name}} <span *ngIf="source.siteType">({{source.siteType.siteTypeCode}})</span></option>
                  </select>
                  <button [disabled]="dashboardToAdd == null" class="btn btn-default btn-outline" (click)="addDashboardToList(dashboardToAdd)"><i class="fa fa-plus"></i></button>
                </div>
              </div>
              <div class="card-body h-300px flex-grow-1 overflow-auto">
                <ng-template #itemTemplate let-item="item" let-index="index">
                  <div class="d-flex">
                    <span class="flex-grow-1">{{item.value.name}}</span>
                    <span class="float-right btn-group">
                      <input [(ngModel)]="item.value.displaySeconds" type="number" class="form-control form-control-sm" placeholder="Display Time" min="0" max="120"/>
                      <button class="btn btn-default btn-outline" (click)="removeDashboard(item.value)"><i class="fa fa-trash"></i></button>
                    </span>                  
                  </div>
                  <div *ngIf="item && item.value && item.value.siteType">Site Type: {{item.value.siteType.siteTypeCode}}</div>
                  <div *ngIf="item && item.value && item.value.siteType">
                    <select [(ngModel)]="item.value.siteUri" class="form-select">
                      <option value="all">All</option>
                    </select>
                  </div>
                </ng-template>
 
                <bs-sortable
                    [(ngModel)]="newDashboardList.dashboards"
                    itemClass="list-group-item"
                    [itemTemplate]="itemTemplate"
                    itemActiveClass="sortable-item-active"
                    placeholderItem="Add a Dashboard"
                    placeholderClass="list-group-item text-center bg-green bg-opacity-30 h-100px"
                    wrapperClass="list-group bg-emphasis bg-opacity-25"
                  ></bs-sortable>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="addDashboardList.hide()" class="btn btn-white">Close</button>
        <button *ngIf="!editDashboardList" (click)="addNewDashboardList();addDashboardList.hide()" class="btn btn-white">Add</button>
        <button *ngIf="editDashboardList" (click)="updateDashboardList();addDashboardList.hide()" class="btn btn-white">Update</button>
        <button *ngIf="editDashboardList" (click)="deleteDashboardList();addDashboardList.hide()" class="btn btn-danger">Delete</button>
      </div>
    </div>
  </div>
</div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-xl-9">
        <div class="card mt-2 bg-emphasis bg-opacity-25">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <span class="flex-grow-1">
                <button *ngIf="azureAuthService.isDashboardEditor()" (click)="this.showAddDashboard()" class="btn btn-outline-default">Add New</button>
              </span>                    
              <span>
                <div class="form-group float-right btn-group">
                  <div class="input-group mr-3">
                    <input type="text" placeholder="Search by name..." class="form-control" [(ngModel)]="service.searchFilter" (change)="doSearch()" (keyup.enter)="doSearch()">
                    <button type="button" class="btn btn-outline-default" (click)="doSearch()"  [disabled]="service.loading"><i class="bi bi-search"></i> </button>
                    &nbsp;
                  </div>

                  <div class="filter-button" dropdown>
                    <button id="button-basic" dropdownToggle type="button" class="btn btn-outline-default dropdown-toggle" aria-controls="dropdown-basic">
                    Category : {{category}} 
                    </button>
                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                      <li role="menuitem"><a class="dropdown-item" (click)="clearFilterCategory(10)">Clear</a></li>  
                      <li role="menuitem" *ngFor="let category of categories"><a class="dropdown-item" (click)="filterCategory(category)">{{category}}</a></li>
                    </ul>
                  </div>
                </div>
              </span>
            </div>
            <table class="table table-striped"> 
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Dashboard Name</th>
                  <th scope="col" class="d-none d-xl-table-cell">Created By</th>
                  <th scope="col" class="d-none d-lg-table-cell text-center h">Public</th>
                  <th scope="col" class="d-none d-sm-table-cell text-center">Shared</th>
                  <th scope="col" class="d-none d-sm-table-cell text-center">Category</th>
                  <th scope="col" class="d-none d-xl-table-cell text-center" *ngIf="azureAuthService.isAdmin()">Site Type</th>
                  <th scope="col" class="text-center"></th>
                  <th scope="col" class="text-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="service.loading">
                  <td colspan="9"><div class="spinner-border"></div></td>
                </tr>
                <tr *ngFor="let dashboard of remoteData | async">
                  <td scope="row"><a href="#/dashboard/{{dashboard.dashboardId}}">{{dashboard.dashboardId}}</a></td>
                  <td>{{dashboard.name}}</td>
                  <td class="d-none d-xl-table-cell">{{dashboard.createdBy}}</td>
                  <td class="d-none d-lg-table-cell text-center"><i class="fa fa-check" *ngIf="dashboard.publishedToPublic" title="Shared with the Public"></i></td>
                  <td class="d-none d-sm-table-cell text-center">
                    <i class="fa fa-check" *ngIf="dashboard.published" title="Shared with my Team"></i>
                    <a class="btn btn-sm btn-outline-primary" *ngIf="!dashboard.published" title="Share with my Team" (click)="shareDashboard(dashboard)"><i class="fa fa-eye"></i></a>
                  </td>
                  <td class="d-none d-sm-table-cell text-center">{{dashboard.category}}</td>
                  <td class="d-none d-xl-table-cell text-center" *ngIf="azureAuthService.isAdmin()">{{dashboard.siteType}}</td>
                  <th class="d-none d-sm-table-cell">
                    <a class="btn btn-outline-default btn-sm" *ngIf="!dashboard.isFavourite" (click)="makeFavourite(dashboard)"><i class="fa fa-star-o"></i></a>
                    <a class="btn btn-outline-default btn-sm" *ngIf="dashboard.isFavourite" (click)="removeFavourite(dashboard)"><i class="fa fa-star"></i></a>
                  </th>
                  <th><a class="btn btn-outline-default btn-sm" href="#/dashboard/{{dashboard.dashboardId}}">Open</a></th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-xl-3">
        <div class="card mt-2 bg-emphasis bg-opacity-25">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <span class="flex-grow-1">
                <button *ngIf="azureAuthService.isDashboardEditor()" (click)="this.showAddDashboardList()" class="btn btn-outline-default">Add New Dashboard List</button>
              </span>                    
            </div>
            <table class="table table-striped"> 
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">List Name</th>
                  <th scope="col" class="text-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="listservice.loading">
                  <td colspan="9"><div class="spinner-border"></div></td>
                </tr>
                <tr *ngFor="let list of listRemoteData | async">
                  <td scope="row"><a href="#/dashboard-list/{{list.dashboardListId}}">{{list.dashboardListId}}</a></td>
                  <td>{{list.listName}}</td>
                  <th>
                    <a *ngIf="azureAuthService.isDashboardEditor()" class="btn btn-outline-default btn-sm" (click)="showEditDashboardList(list.dashboardListId)"><i class="fa fa-pencil"></i></a>
                    <a class="btn btn-outline-default btn-sm mx-2" href="#/dashboard-list/{{list.dashboardListId}}"><i class="fa fa-play"></i></a>
                    <a *ngIf="list.publishedBy" class="btn btn-outline-default btn-sm" target="_blank" href="{{getPublishedCode(list)}}"><i class="fa fa-eye"></i></a>

                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>